import { IntegerArbitrary } from './_internals/IntegerArbitrary.js';
const safeMaxSafeInteger = Number.MAX_SAFE_INTEGER;
export function maxSafeNat() {
    return new IntegerArbitrary(0, safeMaxSafeInteger);
}
